import React from 'react';


class Introduction extends React.Component {
    render() {

        var introSectionStyle = {
            marginTop: 15,
            marginBottom: 15,
            marginLeft: 30,
            marginRight: 30,
            color: "#e0e0e0"
        }

        return (
            <section style={introSectionStyle}>
                <p>I have been a contract software developer for many years. I have accumulated broad and deep experience in many development environments, on many platforms and in many diverse industries.</p>
                <p>I am based in Burlington VT but have many years of experience successfully executing long term remote contracts. In fact, I have many long-term clients which I have never actually met.</p>
                <p></p>
            </section>
        );
    }
}

export default Introduction


// WEBPACK FOOTER //
// src/static/Introduction.js